<!--
 * @Author: your name
 * @Date: 2019-06-05 14:12:21
 * @LastEditTime: 2020-03-09 16:42:08
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \floor\src\components\head.vue
 -->
<template>
	<div id="head">
		<div class="logoWrap">
			<img class="logo" src="../assets/logo.png" alt="">
		</div>
		<nav class="nav">
			<ul class="list">
				<!-- <li class="navItem">HOME</li>
				<li class="navItem active">GALLERY</li>
				<li class="navItem">ABOUT US</li>
				<li class="navItem">PRODUCTS</li>
				<li class="navItem"><a style="color: #fff" href="http://www.kingdomflooring.com.cn">SERVICE</a></li>
				<li class="navItem">SERVES</li>
				<li class="navItem">CONTACT US</li> -->
        <li :class="['navItem', index === 1 && 'active']" v-for="(item, index) in navList" :key="index">
          <a style="color: #fff" :href="item.href">{{item.name}}</a>
        </li>
			</ul>
		</nav>
	</div>
</template>

<script>
  export default {
    data () {
      return {
        navList: [{
          name: 'HOME',
          href: ' https://www.kingdomflooring.com.cn/'
        }, {
          name: 'ABOUT US',
          href: ' https://www.kingdomflooring.com.cn/about'
        }, {
          name: 'PRODUCTS',
          href: ' https://www.kingdomflooring.com.cn/product'
        }, {
          name: 'NEWS',
          href: ' https://www.kingdomflooring.com.cn/news'
        }, {
          name: 'SERVICE',
          href: ' https://www.kingdomflooring.com.cn/service'
        }, {
          name: 'CONTACT US',
          href: ' https://www.kingdomflooring.com.cn/contact'
        }]
      }
    }
  }
</script>

<style lang="scss" scoped>
	#head{
		width:1634px;
		margin: 65px auto 56px;
		display: flex;
		justify-content: space-between;
		font-family: Arial;
		.logo {
			height: 51px;
		}
		.nav{
			.list{
				height: 51px;
				line-height: 51px;
				display: flex;
			}
			.navItem{
				padding: 0 10px;
				margin-right: 44px;
				/* font-size: 20px; */
				color: #fff;
				&.active{
					background-color: #e50212;
				}
				&:last-child{
					margin-right: 0;
				}
			}
		}
	}
</style>
